import type { FaireProductEntity } from "../../entity_types/product";

export const p_j9rp2tp74j: FaireProductEntity = {
  token: "p_j9rp2tp74j",
  type: "product",
  name: "Sparkling Colored Cubic Zirconia Stainless Steel Ring - FGS",
  brandToken: "b_nex9pcmkzj",
  brandName: "Mio Queena",
  imageUrl:
    "https://cdn.faire.com/fastly/df5b77f8939051e4cb8cec7a47a268ae5b83ec33abeb362ea5664da514ce5fe0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f6fefb6de5cafa2eb4a09e304a84923b017d7bdd1f8ba68119168947db33033c.jpeg",
    "https://cdn.faire.com/fastly/9842289b9e91d472302e206a293069c147ad1290e0ba87628b4fcd004f157237.jpeg",
    "https://cdn.faire.com/fastly/7e7aaca7e9df0b9a8b65373367529fa7f5a2ced952fbab97d8d3c82de40367ed.jpeg",
    "https://cdn.faire.com/fastly/525f08c36906c099b94d7b231a893104d52f73ec58e474beaf45f8f3458a7042.jpeg",
    "https://cdn.faire.com/fastly/757b5202c76b8ff2c00a072e8fc4b54be2426269bb83c55f8571475e87b176f7.jpeg",
    "https://cdn.faire.com/fastly/2024bb301a7452d8bfabecf1718ee4c66604bc9caa295df3462a6dd577f39c04.jpeg",
    "https://cdn.faire.com/fastly/9e4c8a725acccaad06bceae762a95709d11234b41f1f37223b34505e960cf939.jpeg",
    "https://cdn.faire.com/fastly/b88c595fc0e4af0b72a83e88e15d31fac74cf971d7cf13b5866e6b92b59f4ac0.jpeg",
    "https://cdn.faire.com/fastly/178b8a1e8ebb36132cb3b2cf7b5bb39cbb696de9ef4d50146fc5295978f1de6c.jpeg",
    "https://cdn.faire.com/fastly/98089a63dca8682f4c6f623c7399b2f8d25fe4ca1ecd2b1eeeab8559b5b1fb55.jpeg",
    "https://cdn.faire.com/fastly/80a4e8e3f3d4c7fbbe10a818d14a5c73df3ca680108f91f7ca65354ab2161cf7.jpeg",
    "https://cdn.faire.com/fastly/1a78b678bee8f8a4a3d7b7f33d383ce55db51a6ead3058340bb5f31d2c108274.jpeg",
    "https://cdn.faire.com/fastly/42aad8e7e5aed1036c218a48da57d3e2a0ca48f4bffee739da020e1d543baca1.jpeg",
    "https://cdn.faire.com/fastly/15203b2752d3217eb553249dcb7e3fb06875b828addb4a29b05216875b2b22a0.jpeg",
    "https://cdn.faire.com/fastly/9f8dfc0f39bd228f7d485b8b7d7c67199e7c1bf35344503c3cb6ff5587dc9b9e.jpeg",
    "https://cdn.faire.com/fastly/61ce22e726ee23890a956fbf05d84b9dc64bb0021f30d3b550a3e0dae8bd2935.jpeg",
  ],
  priceDollars: 5.89,
  description:
    "Type: Ring\nMaterial : Cubic zirconia，Stainless steel ，18K gold plated\nSize ： width-6mm\nProcess: Vacuum electroplating and manual polishing \nSurface : High Polish\n★Made of high quality stainless steel，Lead-free，Harmless to Human Body.\n★Perfect jewelry gifts",
  tags: [],
  msrpDollars: 16.49,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:57:41.088Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
